import React from 'react';
import { Link } from 'react-router-dom';
import './footer.css';
import logoWhite from '../../Assets/JMD INFORMATIQUE WHITE.png';

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__grid">
          {/* Brand */}
          <div className="footer__brand">
            <img src={logoWhite} alt="JMD Informatique" className="footer__logo-img" />
            <p className="footer__tagline">Dépannage informatique à domicile<br />dans le Var</p>
          </div>

          {/* Services */}
          <div className="footer__col">
            <h4 className="footer__col-title">Services</h4>
            <ul className="footer__list">
              <li>Diagnostic &amp; devis — <span className="footer__price">20 €</span></li>
              <li>Dépannage standard — <span className="footer__price">dès 50 €</span></li>
              <li>Dépannage avancé — <span className="footer__price">dès 75 €</span></li>
              <li>Initiation — <span className="footer__price">45 €/h</span></li>
              <li>Solutions web — <em>sur demande</em></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer__col">
            <h4 className="footer__col-title">Contact</h4>
            <ul className="footer__list">
              <li>
                <a href="tel:0781165306" className="footer__phone">
                  <i className="fa-solid fa-phone"></i>
                  07 81 16 53 06
                </a>
              </li>
              <li>
                <i className="fa-solid fa-location-dot footer__icon"></i>
                Six-Fours, Sanary, Bandol
              </li>
              <li>
                <i className="fa-solid fa-clock footer__icon"></i>
                Soirs après 20h · Week-ends
              </li>
              <li>
                <i className="fa-solid fa-car footer__icon"></i>
                Déplacements toujours inclus
              </li>
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <p className="footer__legal">
            © {year} JMD Informatique · SIRET 103 158 135 00014 · <Link to="/contact">Contact</Link> · <Link to="/mentions-legales">Mentions légales</Link>
          </p>
          <p className="footer__credit">
            Prestations SAP agréées
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
